import { Component } from '@angular/core'

@Component({
  selector: 'my-account-abuses-list',
  templateUrl: './my-account-abuses-list.component.html',
  styleUrls: [ ]
})
export class MyAccountAbusesListComponent {

}
